function FVAccess_FireEvent(eventName, sourceId, targetId, paramObj) {
  try {
    // eslint-disable-next-line no-restricted-globals
    if (parent.FVWebComponent) {
      // eslint-disable-next-line no-restricted-globals
      parent.FVWebComponent.fireEvent(eventName, sourceId, targetId, paramObj);
    }
  } catch (e) {
    console.log("not wrapped by us");
  }
}

export function fvaxSignal(why, custId, toolId) {
  //signal wrapper, happens on load
  const paramObj = {};
  paramObj.toolType = paramObj.state = FVAccessTool.ROUTEMAPPER;
  paramObj.custId = custId;
  paramObj.toolId = toolId;
  paramObj.why = why;
  FVAccess_FireEvent(
    FVAccessEvent.UPDATE,
    custId + "_" + toolId,
    null,
    paramObj
  );
}

const FVAccessEvent = {};
FVAccessEvent.INIT = "FVACCESS_INIT";
FVAccessEvent.UPDATE = "FVACCESS_UPDATE";

const FVAccessTool = {};
FVAccessTool.FIDS = "FVACCESS_FIDS";
FVAccessTool.AIRTRAFFICMAP = "FVACCESS_AIRTRAFFICMAP";
FVAccessTool.TRACKER = "FVACCESS_TRACKER";
FVAccessTool.ROUTEMAPPER = "FVACCESS_ROUTEMAPPER";
FVAccessTool.WEATHER = "FVACCESS_WEATHER";
